export const left = {
  id: '4-left',
  name: 'Left of Sink',
  levels: [
    {
      tileSize: 256,
      size: 256,
      fallbackOnly: true,
    },
    {
      tileSize: 512,
      size: 512,
    },
    {
      tileSize: 512,
      size: 1024,
    },
    {
      tileSize: 512,
      size: 2048,
    },
  ],
  faceSize: 2048,
  initialViewParameters: {
    yaw: -0.18801170556135993,
    pitch: 0.4299088399273945,
    fov: 1.4254872060750312,
  },
  linkHotspots: [
    {
      yaw: -2.3460745222347636,
      pitch: 0.4344653089210695,
      rotation: 7.853981633974483,
      target: '1-dining',
    },
    {
      yaw: -2.9206279892374205,
      pitch: 0.35337205286978346,
      rotation: 4.71238898038469,
      target: '2-island',
    },
    {
      yaw: 2.699814367893186,
      pitch: 0.0713820725473866,
      rotation: 16.493361431346422,
      target: '0-countertop',
    },
    {
      yaw: 2.375470031844883,
      pitch: 0.20783458196301652,
      rotation: 5.497787143782138,
      target: '3-range',
    },
    {
      yaw: 1.5981337775827038,
      pitch: 0.5996656039859651,
      rotation: 5.497787143782138,
      target: '5-right',
    },
  ],
  infoHotspots: [
    {
      yaw: 0.02600750621008885,
      pitch: 0.334845821922233,
      title: 'Bread Mixes',
      text: `
<ul>
<br/>
<span class="title">Italian Herb Bread Mix</span>
<li><span class='b'>#100522</span></li>
<li> <span class='b'>USD</span> $9 | <span class='b'>CAD</span> $12</li>
<li> Kosher | Contains wheat, barley, and milk. </li>
<li> 12.4 oz. (351 g)</li>
<li> A savory Tuscan blend of garlic, rosemary, basil, parsley, and onion!</li>
<li> Make your own homemade artisan bread but don’t have the time or skill, just add water for a crusty, airy loaf with savory Tuscan flavors.</li>
<li> <span class='b'>Great for:</span> one standard loaf or mini loaves.</li>

<br/>
<span class="title">Caramel Latte Bread Mix</span>
<li><span class='b'>#100523</span></li>
<li><span class="b">USD</span> $9 | <span class="b">CAD</span> $12</li>
<li> Kosher  |  Contains wheat, barley, and milk. </li>
<li> 13.5 oz. (382 g)</li>
<li> Easy-to-make mix you can enjoy all the complex flavors of caramel latte bread made at home. Just add eggs, oil, and water. </li>
<li> Enjoy a slice of buttery caramel bread with a nice cup of coffee, an after-dinner treat, or give as a thoughtful and delicious gift.</li>
<li> <span class='b'>Great for:</span> one standard loaf, four mini loaves, or muffins of any size.</li>
<li> Also in the <span class="b">Quick Bread Set:</span> Caramel Latte Bread Mix and Stone Loaf Pan</li>
<li><span class='b'> Round-Up From the Heart® products:</span><br/> Quick Bread Set, Stone Loaf Pan, or Stoneware Starter Set</li>

</ul>
      `,
      images: [
        { id: `bb9wgitydv`, key: `nc1-gs2-27` },
        { id: `vmlf35duhc`, key: `nc1-gs2-28` },
        { id: `gk77mtsg5g`, key: `nc1-gs2-29` },
        { id: `xvfiuozf65`, key: `nc1-gs2-30` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/569999760" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
        `<iframe src="https://player.vimeo.com/video/569999497" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
    {
      yaw: -0.6276241691345632,
      pitch: 0.4550933039763603,
      title: 'Deluxe Air Fryer & Accessories',
      text: `
        <ul>
          <br />
          <br />
          <li><span class="title">Deluxe Air Fryer</span></li>
          <li><span class="b"> #100194</span></li>
          <li>
            <span class="b">USD</span> $289 | <span class="b">CAD</span> $310
          </li>
          <li>1-year guarantee</li>
          <li>
            Dishwasher-safe: removable shield, cooking trays, rotating basket,
            retrieval tool, and rotisserie set. Hand wash: drip tray.
          </li>
          <li>14½" x 12¾" x 14¼" (37 cm x 32 cm x 35.5 cm)</li>
          <li>
            Family-sized 11.6-qt. (11-L) capacity fits up to a 4-lb. (1.8-kg)
            whole chicken.
          </li>
          <li>
            Includes two cooking trays, basket, rotisserie set, drip tray,
            retrieval tool, removable shield, and a cooking guide.
          </li>
          <li>
            Eight programmed settings: Air Fry, Bake, Roast, Rotisserie, Reheat,
            Dehydrate, Custom, and Rotate
          </li>
          <li>
            Enjoy fried foods at home without all the mess, hassle, and oil of
            deep frying but with all the flavor and texture you love. Like a
            convection oven, superheated air circulates giving food a crispy
            texture. No preheating is necessary, saving you precious time.
            Conveniently fits under kitchen cabinets.
          </li>
          <li>
            Great for: crispy chicken tenders, wings, French fries, roasted
            veggies, perfectly-cooked rotisserie chicken, dehydrated fruits and
            veggies, appetizers, desserts, and crisp leftovers.
          </li>
          <li>
            <span class="b teal-text"
              >Get it at a discount or for free when you host a party. Ask your
              consultant for details.</span
            >
          </li>
          <br />
          <br />

          <span class="title">Deluxe Air Fryer Mess Catcher</span>
          <li><span class="b"> #100468</span></li>
          <li>
            <span class="b">USD</span> $25 | <span class="b">CAD</span> $35
          </li>
          <li>3-year guarantee</li>
          <li>Dishwasher-safe | Oven-safe to 400°F (200°C)</li>
          <li>9" x 10¼" (23 cm x 25.5 cm)</li>
          <li>For use only with the Pampered Chef Deluxe Air Fryer.</li>
          <li>
            Mess-catching tray keeps crumbs, oil, and melted cheese contained.
          </li>
          <li>
            Metal mesh screen has tiny holes that lets air circulate for even
            and thorough cooking and sits on a silicone drip tray to catch oil,
            grease, batter, etc.
          </li>
          <li>
            Tray’s wire frame adds stability so it can be used in place of one
            of the original trays. It can also be used in the oven when placed
            on top of a cookie sheet.
          </li>
          <li>
            <span class="b">Great for:</span> chicken nuggets and tenders,
            nachos, French fries, breaded shrimp, bacon, and French toast.
          </li>

          <br />
          <br />

          <li><span class="title">Deluxe Air Fryer Skewers</span></li>
          <li><span class="b"> #100285</span></li>
          <li>
            <span class="b">USD</span> $26 | <span class="b">CAD</span> $37
          </li>
          <li>1-year guarantee</li>
          <li>Dishwasher-safe</li>
          <li>9" x 10¼" (23 cm x 25.5 cm)</li>
          <li>
            Includes eight 8" (20-cm) stainless-steel skewers, a rotisserie bar,
            and two rotisserie wheels.
          </li>
          <li>
            The flat stainless-steel skewers keep food in place to perfectly
            cook it on all sides. The skewers also stay far enough apart so that
            the kebabs or hot dogs won’t touch each other. That helps everything
            cook evenly, too.
          </li>
          <li>
            <span class="b">Great for:</span> rotisserie-style kebabs, sausages,
            and hot dogs.
          </li>
          <br />
          <br />
          <li>
            <span class="title">Deluxe Air Fryer Fruit Leather Trays</span>
          </li>
          <li><span class="b"> #100349</span></li>
          <li>
            <span class="b">USD</span> $36 | <span class="b">CAD</span> $47
          </li>
          <li>1-year guarantee</li>
          <li>Dishwasher-safe</li>
          <li>
            Set of 3; 10" x 8¾" (25 cm x 22.5 cm); each well: 2 tbsp (30 mL).
          </li>
          <li>
            Each tray has a wire rim, so you can easily slide it into the Deluxe
            Air Fryer, and is made of silicone, which is ideal for removing
            fruit leather.
          </li>
          <li>
            Just pour fruit puree into the wells and bake in the oven or
            dehydrate in our Deluxe Air Fryer.
          </li>
          <li>
            Make up to 24 fruit leather at once—enough for several snack
            sessions or your next outdoor get-together!
          </li>
        </ul>
      `,
      images: [
        { id: `xputk71ho3`, key: `nc1-gs3-1` },
        { id: `xfnru5iswt`, key: `nc1-gs3-2` },
        { id: `ajy5lnmxlo`, key: `nc1-gs3-2-3` },
        { id: `jw5esv2usm`, key: `nc1-gs3-2-4` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/585028548" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
        `<iframe src="https://player.vimeo.com/video/569999657" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`,
      ],
    },
    {
      yaw: 0.6471248978126951,
      pitch: 0.4568521190795849,
      title: 'Pumpkin Carving Kit',
      text: `
<ul>
<li><span class='b'> #100490</span></li>
<li> <span class='b'>USD</span> $17 | <span class='b'>CAD</span> $20</li>
<li> My Safe Cutter: 2-year guarantee<br/> Scoop Loop™: 1-year guarantee</li>
<li> Dishwasher-safe</li>
<li> My Safe Cutter: 2¾" (7 cm) blade.<br/> Scoop Loop™: 5" (13 cm).</li>
<li> Includes: NEW My Safe Cutter and Scoop Loop™</li>
<li> Safely carve fun designs for Halloween masterpieces.</li>
<li> Use the Scoop Loop™ to easily scoop out the pulp and seeds. </li>
<li> The serrated knife is also great to cut apples, sandwiches, and pancakes. </li>
<li> <span class='b'>Great for:</span> pumpkins, melons, tomatoes, bell peppers.</li>

</ul>
        `,
      images: [
        { id: `o5lfynelbp`, key: `nc1-gs3-7` },
        { id: `bbiufqdm3f`, key: `nc1-gs3-8` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/569999911" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
    {
      yaw: 0.6766667862491662,
      pitch: 0.7035272141166065,
      title: 'Cheese Knife',
      text: `
<ul>
<li><span class='b'> #100478</span></li>
<li> <span class='b'>USD</span> $17 | <span class='b'>CAD</span> $24</li>
<li> 3-year guarantee</li>
<li> Dishwasher-safe</li>
<li> 7¾" (19.5 cm)</li>
<li> Stainless steel blade with a polypropylene handle and protective cover.</li>
<li> Two cheese cutting tools in one—a knife and a planer.</li>
<li> Use the knife to cut hard and soft cheese to whatever thickness you prefer and the planer to slice semi-firm cheese like Parmesan and cheddar.</li>
<li> Features a fork tip to pick up and move cubes or slices.</li>
<li> Protective cover slides over the blade to safely plane cheese and store the knife.</li>
<li><span class='b'>Great for:</span> hard and soft cheese, snacks, impressive snack boards, salads, pastas, and more.</li>

</ul>
        `,
      images: [
        { id: `0el99vv4ww`, key: `nc1-gs3-3` },
        { id: `rhhylm08rf`, key: `nc1-gs3-4` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/569999589" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`,
      ],
    },
  ],
};
